<div class="community-metrics flex flex-col gap-6">
  <!-- Stat card -->
  <div
    class="bg-[#fcfcfc] border border-[#eeeeef] rounded-[0.25rem] box-border md:hidden flex flex-col items-center justify-center gap-[0.75rem] px-[2rem] py-[1.25rem] w-full h-full"
  >
    <!-- Icon wrapper -->
    <div
      class="bg-[#e6f2fa] rounded-[0.5rem] flex items-center justify-center p-[0.5rem] box-border w-[2.5rem] h-[2.5rem]"
    >
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M7.58081 1.00781C8.09123 1.06474 8.47704 1.40762 8.78394 1.74512L9.17554 2.19727C11.0117 4.41899 11.9939 7.15035 11.905 9.66016L11.8923 9.91895C11.7871 11.5277 11.2112 12.8497 10.2507 13.7441C9.5516 14.3949 8.67839 14.7881 7.70972 14.916C7.57825 15.7756 7.35053 16.5636 7.04565 17.2744C7.79083 17.0288 8.65443 16.8923 9.5769 17.0264C10.3571 15.6446 11.6031 14.9158 12.9695 14.6621C14.4595 14.3858 16.0892 14.6688 17.4773 15.2207C18.2729 15.5363 19.171 15.6786 19.8894 15.7393C20.2443 15.7692 20.5479 15.7785 20.7605 15.7803C20.8662 15.7812 20.9501 15.7804 21.0056 15.7793C21.033 15.7787 21.0549 15.7778 21.0681 15.7773C21.0741 15.7771 21.0791 15.7765 21.0818 15.7764H21.0837L21.2185 15.7842C21.3511 15.8056 21.4753 15.8687 21.573 15.9639C21.703 16.0908 21.7748 16.2656 21.7712 16.4473C21.7457 17.7353 21.1477 19.5562 19.6941 21.0674L19.3923 21.3652C17.8378 22.8176 15.1358 23.3084 12.9597 22.8047C12.7787 22.7628 12.6001 22.7101 12.4236 22.6533C12.3982 22.6458 12.3724 22.6384 12.3484 22.6279C11.4768 22.3354 10.6777 21.8585 10.0994 21.1533C9.48558 20.4047 9.15827 19.4487 9.21265 18.3135C7.72379 18.1662 6.42173 18.9186 5.698 19.4414C4.95747 20.2968 4.07826 20.9412 3.14331 21.3525C2.8108 21.4984 2.42246 21.347 2.27612 21.0146C2.12984 20.6822 2.28081 20.2941 2.61304 20.1475C4.30749 19.402 5.89429 17.652 6.37476 14.9277C5.0412 14.7843 3.93923 14.2051 3.19897 13.2217C2.43136 12.2016 2.10857 10.8245 2.22144 9.23828L2.26929 8.72461C2.56537 6.15313 3.72816 3.57031 6.23804 1.51855L6.37964 1.40723C6.71883 1.15517 7.11837 0.956558 7.58081 1.00781ZM19.6472 18.9697C19.0583 19.2656 18.3251 19.4603 17.4265 19.4463C17.4162 19.4714 17.4066 19.498 17.3953 19.5244C17.2483 19.8659 17.0096 20.3238 16.6433 20.7842C16.4243 21.0592 16.1591 21.3332 15.8445 21.585C16.8901 21.4104 17.8526 21.0023 18.4929 20.4043L18.7468 20.1533C19.1122 19.7732 19.4085 19.3706 19.6472 18.9697ZM16.991 16.4434C15.7635 15.9554 14.391 15.737 13.2097 15.9561C12.2736 16.1298 11.4564 16.5745 10.8894 17.4033C11.1418 17.5135 11.3974 17.6459 11.6531 17.8066L11.9402 17.998L12.0408 18.0869C12.2496 18.3101 12.2806 18.6566 12.0974 18.916C11.9138 19.1751 11.5766 19.2612 11.2966 19.1387L11.1794 19.0732L10.9646 18.9297C10.8177 18.8371 10.671 18.7559 10.5251 18.6855C10.5507 19.3708 10.7776 19.9044 11.1169 20.3184C11.494 20.7782 12.0449 21.1292 12.7097 21.3613C13.2459 21.3418 13.7043 21.2439 14.0955 21.0918C13.7787 20.943 13.4917 20.7421 13.2615 20.4844C12.8316 20.0029 12.6272 19.3629 12.7498 18.6514L12.7771 18.5176C12.9272 17.862 13.3178 17.3717 13.8582 17.0879C14.4121 16.7975 15.0703 16.7492 15.699 16.8613L15.8767 16.8975C16.6023 17.0652 17.2896 17.4631 17.6482 18.1289C18.6874 18.097 19.3495 17.6929 19.7664 17.291C19.8442 17.2159 19.9132 17.1373 19.9763 17.0625C19.9125 17.0581 19.8454 17.0565 19.7781 17.0508C18.9973 16.9848 17.9553 16.8259 16.991 16.4434ZM15.4666 18.1562C15.0415 18.0806 14.6979 18.1341 14.4695 18.2539C14.2638 18.362 14.1049 18.5466 14.0476 18.876C13.9943 19.1872 14.0785 19.4232 14.2439 19.6084C14.4228 19.8084 14.729 19.9813 15.1453 20.0557H15.1482L15.2937 20.0771C15.3678 20.0853 15.4408 20.088 15.5105 20.0879C15.546 20.0468 15.5803 20.005 15.613 19.9639C15.89 19.6158 16.0726 19.2666 16.1853 19.0049C16.2412 18.875 16.2804 18.7683 16.3035 18.6973C16.3149 18.6622 16.3224 18.635 16.3269 18.6191C16.3288 18.6124 16.33 18.6072 16.3308 18.6045C16.3342 18.5909 16.3403 18.5776 16.3445 18.5645C16.1653 18.3827 15.8785 18.2301 15.4666 18.1562ZM7.42847 2.31641C7.42053 2.31786 7.40178 2.32237 7.3728 2.33496C7.34134 2.34872 7.30107 2.37124 7.25171 2.40332L7.07104 2.53711C4.85389 4.34955 3.83725 6.60829 3.5769 8.87793L3.53491 9.33105C3.43757 10.6986 3.72576 11.733 4.25073 12.4307C4.74215 13.0834 5.49261 13.5102 6.51343 13.6201C6.51912 13.4779 6.52416 13.333 6.52417 13.1865C6.52417 12.8233 6.81826 12.5287 7.1814 12.5283C7.54489 12.5283 7.8396 12.8231 7.8396 13.1865C7.8396 13.3127 7.83756 13.4379 7.83374 13.5615C8.42736 13.4333 8.94077 13.1652 9.35425 12.7803C10.0213 12.1589 10.4908 11.1777 10.5789 9.83301L10.5945 9.38867C10.6061 7.29665 9.76071 4.97235 8.16382 3.03906L7.8103 2.63086C7.6818 2.48953 7.58643 2.40641 7.51733 2.35938C7.48489 2.33735 7.46262 2.32642 7.44995 2.32129C7.44419 2.31895 7.44036 2.317 7.43823 2.31641H7.43628L7.4353 2.31543C7.43438 2.31552 7.43159 2.31586 7.42847 2.31641ZM7.29761 6.13379C8.08981 6.16409 8.71422 6.52617 9.11304 7.10059C9.496 7.65238 9.64033 8.35258 9.61499 9.04785C9.5895 9.74275 9.39381 10.4295 8.97144 10.9512C8.53103 11.4946 7.88109 11.8094 7.08862 11.7793C6.29645 11.749 5.67204 11.3868 5.27319 10.8125C4.89034 10.2609 4.74601 9.56127 4.77124 8.86621C4.79661 8.17124 4.99153 7.4837 5.41382 6.96191C5.85416 6.41835 6.50509 6.1038 7.29761 6.13379ZM7.24683 7.44922C6.8638 7.43487 6.61242 7.57261 6.43628 7.79004C6.24278 8.02944 6.10491 8.41439 6.08667 8.91406C6.06855 9.41393 6.178 9.80862 6.35425 10.0625C6.51467 10.2934 6.75548 10.4491 7.13843 10.4639C7.52162 10.4784 7.77176 10.3404 7.948 10.123C8.14184 9.88376 8.28125 9.49917 8.29956 8.99902C8.31771 8.49909 8.20726 8.10449 8.03101 7.85059C7.87052 7.61971 7.62988 7.46384 7.24683 7.44922Z"
            fill="#007DCB"
          />
        </svg>
      </i>
    </div>

    <!-- Text block -->
    <div class="flex flex-col items-center gap-[0.25rem] w-full">
      <!-- Number -->
      <p class="font-bold text-[1.75rem] leading-[1.4] text-[#003555] text-center">0</p>

      <!-- Label -->
      <p class="font-normal text-[1rem] leading-[1.6] text-[#0072b9]/80 text-center whitespace-nowrap">Total leaves</p>
    </div>
  </div>

  <span class="text-[1.1875rem] md:text-[1.375rem] font-bold text-[#222528] text-center md:text-left">{{
    'dashboard.communitysMetrics' | translate
  }}</span>
  <div class="flex w-full gap-[1rem]">
    <!-- Invitations sent -->
    <div class="flip-card min-w-0 flex-1">
      <div class="flip-card-inner">
        <!-- Front -->
        <div class="flip-card-front px-[0.5rem] py-[1rem]">
          <div class="flex w-full flex-col items-center justify-center gap-[1rem]">
            <div class="flex h-[2.5rem] w-[2.5rem] items-center justify-center rounded-full bg-[#E6F2FA] p-[0.5rem]">
              <div class="relative h-[1.5rem] w-[1.5rem] flex items-center justify-center">
                <!-- моковое изображение -->
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5.56278 11.9999L2.0966 3.08798C1.85537 2.46773 2.46025 1.87456 3.05862 2.0854L3.15293 2.12549L21.5341 11.3149C22.0634 11.5796 22.0965 12.304 21.6334 12.626L21.5341 12.6848L3.15293 21.8743C2.5576 22.1719 1.91088 21.6246 2.06542 21.0094L2.0966 20.9117L5.56278 11.9999ZM4.24391 4.38326L6.90815 11.2335L13.6761 11.2341C14.0639 11.2341 14.3843 11.5222 14.435 11.896L14.442 11.9999C14.442 12.3876 14.1538 12.708 13.78 12.7587L13.6761 12.7657L6.90815 12.7651L4.24391 19.6165L19.4791 11.9999L4.24391 4.38326Z"
                      fill="#007DCB"
                    />
                  </svg>
                </i>
              </div>
            </div>

            <div class="w-full text-center">
              <p
                class="truncate font-['Outfit',sans-serif] font-bold leading-[1.4] text-[#003555] md:text-[1.9375rem] text-[1.75rem]"
              >
                {{ invitationsSent() }}
              </p>
              <p
                class="font-['Outfit',sans-serif] font-normal leading-[1.6] text-[#005990] md:text-[0.9375rem] text-[0.8125rem]"
              >
                {{ 'dashboard.invitationsSent' | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Back -->
        <div class="flip-card-back">
          <p>{{ 'dashboard.invitationsSentBack' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Avg. card spending -->
    <div class="flip-card min-w-0 flex-1">
      <div class="flip-card-inner">
        <!-- Front -->
        <div class="flip-card-front px-[0.5rem] py-[1rem]">
          <div class="flex w-full flex-col items-center justify-center gap-[1rem]">
            <div class="flex h-[2.5rem] w-[2.5rem] items-center justify-center rounded-full bg-[#E6F2FA] p-[0.5rem]">
              <div class="relative h-[1.5rem] w-[1.5rem] flex items-center justify-center">
                <!-- слой карты -->
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                    <rect
                      x="0.835"
                      y="0.835"
                      width="22.33"
                      height="14.6936"
                      rx="1.165"
                      stroke="#007DCB"
                      stroke-width="1.67"
                    />
                    <path
                      d="M18.5454 1.09082V2.36355C18.5454 3.46812 19.4408 4.36355 20.5454 4.36355H22.909"
                      stroke="#007DCB"
                    />
                    <path
                      d="M5.45459 1.09082V2.36355C5.45459 3.46812 4.55916 4.36355 3.45459 4.36355H1.09095"
                      stroke="#007DCB"
                    />
                    <path
                      d="M18.5454 15.2729V14.0002C18.5454 12.8957 19.4408 12.0002 20.5454 12.0002H22.909"
                      stroke="#007DCB"
                    />
                    <path
                      d="M5.45459 15.2729V14.0002C5.45459 12.8957 4.55916 12.0002 3.45459 12.0002H1.09095"
                      stroke="#007DCB"
                    />
                    <path
                      d="M14.366 10.8201V5.54346H16.5893C18.242 5.54346 19.45 6.58101 19.45 8.1818C19.45 9.77518 18.242 10.8201 16.6041 10.8201H14.366ZM16.5893 6.80334H15.8482V9.56026H16.5893C17.4193 9.56026 17.9381 9.10077 17.9381 8.17439C17.9381 7.25541 17.4119 6.80334 16.5893 6.80334Z"
                      fill="#007DCB"
                    />
                    <path
                      d="M11.5544 10.9091C10.6502 10.9091 10.0203 10.6572 9.45703 10.0865L10.3834 9.16012C10.7688 9.53068 11.1838 9.72336 11.6729 9.72336C12.0805 9.72336 12.2881 9.58996 12.2881 9.37504C12.2881 8.61912 9.835 8.92297 9.835 7.09985C9.835 6.07712 10.6132 5.45459 11.8138 5.45459C12.5993 5.45459 13.3108 5.72139 13.7554 6.18087L12.8217 7.10726C12.4956 6.78858 12.1843 6.64036 11.7989 6.64036C11.4877 6.64036 11.295 6.7367 11.295 6.9368C11.295 7.65568 13.748 7.337 13.748 9.21941C13.748 10.294 12.9476 10.9091 11.5544 10.9091Z"
                      fill="#007DCB"
                    />
                    <path
                      d="M6.833 10.9091C5.43972 10.9091 4.52075 9.98269 4.52075 8.67834V5.54346H6.00297V8.81174C6.00297 9.3231 6.36611 9.60472 6.833 9.60472C7.2999 9.60472 7.64081 9.3231 7.64081 8.81915V5.54346H9.13044V8.68575C9.13044 9.9901 8.22628 10.9091 6.833 10.9091Z"
                      fill="#007DCB"
                    />
                  </svg>
                </i>
              </div>
            </div>

            <div class="w-full text-center">
              <p
                class="truncate font-['Outfit',sans-serif] font-bold leading-[1.4] text-[#003555] md:text-[1.9375rem] text-[1.75rem]"
              >
                {{ avgCardSpending() | currency: 'USD' : 'symbol' : '1.0-2' }}
              </p>
              <p
                class="font-['Outfit',sans-serif] font-normal leading-[1.6] text-[#005990] md:text-[0.9375rem] text-[0.8125rem]"
              >
                {{ 'dashboard.avgCardSpending' | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Back -->
        <div class="flip-card-back">
          <p>{{ 'dashboard.avgCardSpendingBack' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- New activations -->
    <div class="flip-card min-w-0 flex-1">
      <div class="flip-card-inner">
        <!-- Front -->
        <div class="flip-card-front px-[0.5rem] py-[1rem]">
          <div class="flex w-full flex-col items-center justify-center gap-[1rem]">
            <div class="flex h-[2.5rem] w-[2.5rem] items-center justify-center rounded-full bg-[#E6F2FA] p-[0.5rem]">
              <div class="relative h-[1.5rem] w-[1.5rem] flex items-center justify-center">
                <!-- моковое изображение -->
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15.75 14.5C15.3358 14.5 15 14.8358 15 15.25C15 15.6642 15.3358 16 15.75 16H18.25C18.6642 16 19 15.6642 19 15.25C19 14.8358 18.6642 14.5 18.25 14.5H15.75ZM2 8.25C2 6.45507 3.45507 5 5.25 5H18.75C20.5449 5 22 6.45507 22 8.25V15.75C22 17.5449 20.5449 19 18.75 19H5.25C3.45507 19 2 17.5449 2 15.75V8.25ZM20.5 9.5V8.25C20.5 7.2835 19.7165 6.5 18.75 6.5H5.25C4.2835 6.5 3.5 7.2835 3.5 8.25V9.5H20.5ZM3.5 11V15.75C3.5 16.7165 4.2835 17.5 5.25 17.5H18.75C19.7165 17.5 20.5 16.7165 20.5 15.75V11H3.5Z"
                      fill="#007DCB"
                    />
                  </svg>
                </i>
              </div>
            </div>

            <div class="w-full text-center">
              <p
                class="truncate font-['Outfit',sans-serif] font-bold leading-[1.4] text-[#003555] md:text-[1.9375rem] text-[1.75rem]"
              >
                {{ newActivations() }}
              </p>
              <p
                class="font-['Outfit',sans-serif] font-normal leading-[1.6] text-[#005990] md:text-[0.9375rem] text-[0.8125rem]"
              >
                {{ 'dashboard.newActivations' | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Back -->
        <div class="flip-card-back">
          <p>{{ 'dashboard.newActivationsBack' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Карточка с графиком (по аналогии с Earnings Growth) -->
  <div
    class="community-metrics__chart card bg-white box-border flex flex-col gap-4 p-6 rounded-[0.25rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
  >
    <!-- Заголовок -->
    <div class="flex flex-col items-start w-full">
      <div class="text-[#505760] text-[1.625rem]/[1.6] font-bold">
        {{ 'myGanarbols.earningGrowth' | translate }}
      </div>
      <div class="text-[#737980] text-[1.125rem]/[1.6]">
        {{ 'my-forest.last6months' | translate }}
      </div>
    </div>

    @if (earningsGrowthGraphResource.status() === 'error') {
      <app-resource-load-error
        data-resource="growth"
        message="balance.earningsGrowthLoadError"
        (retry)="earningsGrowthGraphResource.reload()"
      />
    } @else if (earningsGrowthGraphResource.hasValue()) {
      <!-- Chart Container -->
      <div class="community-metrics__chart-container flex flex-col gap-2 items-start w-full">
        <div class="box-border flex flex-col items-center justify-center overflow-hidden w-full">
          <apx-chart
            appHideApexChartTooltipOnScroll
            class="w-full max-w-[29rem] md:max-w-none"
            [series]="communityMetricsChartOptions().series"
            [chart]="communityMetricsChartOptions().chart"
            [xaxis]="communityMetricsChartOptions().xaxis"
            [yaxis]="communityMetricsChartOptions().yaxis"
            [plotOptions]="communityMetricsChartOptions().plotOptions"
            [dataLabels]="communityMetricsChartOptions().dataLabels"
            [colors]="communityMetricsChartOptions().colors"
            [grid]="communityMetricsChartOptions().grid"
            [tooltip]="communityMetricsChartOptions().tooltip"
            [legend]="communityMetricsChartOptions().legend"
            [states]="communityMetricsChartOptions().states"
          ></apx-chart>
        </div>
      </div>

      <!-- Подвал с трендом -->
      <div class="flex flex-col items-start justify-center w-full">
        <div class="flex gap-1 items-center">
          <div class="text-[#505760] text-[1.125rem]/[1.6]">
            @if (isTrendUp()) {
              {{ 'cardDetails.chart.trendingUp' | translate: { count: trendPercentage() } }}
            } @else {
              {{ 'cardDetails.chart.trendingDown' | translate: { count: trendPercentage() } }}
            }
          </div>
          <div class="overflow-hidden">
            @if (isTrendUp()) {
              <!-- Trending up icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="size-full"
              >
                <path
                  d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                  fill="#078339"
                />
              </svg>
            } @else {
              <!-- Trending down icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="size-full"
              >
                <path
                  d="M13.7489 18L21.3027 17.9995L21.403 17.9856L21.5018 17.958L21.5621 17.9324C21.6413 17.8975 21.7155 17.8469 21.7808 17.7816L21.8215 17.7376L21.865 17.6812L21.9192 17.5911L21.9579 17.5008L21.977 17.4367L21.9906 17.3727L22 17.2785L22.0004 9.74609C22.0004 9.33188 21.6647 8.99609 21.2504 8.99609C20.8708 8.99609 20.557 9.27824 20.5073 9.64432L20.5004 9.74609L20.5 15.441L12.7812 7.7207C12.5149 7.45443 12.0982 7.43024 11.8046 7.64808L11.7205 7.7207L8.75001 10.6911L3.28033 5.22142C2.98744 4.92853 2.51256 4.92853 2.21967 5.22142C1.9534 5.48768 1.9292 5.90434 2.14705 6.19796L2.21967 6.28207L8.21967 12.2821C8.48593 12.5483 8.90259 12.5725 9.1962 12.3547L9.28032 12.2821L12.2508 9.31171L19.438 16.5H13.7489C13.3692 16.5 13.0554 16.7822 13.0058 17.1482L12.9989 17.25C12.9989 17.6297 13.2811 17.9435 13.6472 17.9932L13.7489 18Z"
                  fill="#D92D20"
                />
              </svg>
            }
          </div>
        </div>
        <div class="text-[#737980] text-[0.9375rem]/[1.6]">
          {{ 'balance.showingMonthlyCommissions' | translate }}
        </div>
      </div>
    }
  </div>

  <!-- Grow Your Community (последняя карточка) -->
  <div class="community-metrics__grow card mt-2 flex gap-4 px-6 py-4 rounded-lg items-center">
    <div class="flex flex-col flex-1">
      <div class="text-[1.1875rem]/[160%] md:text-[1.375rem] font-bold text-[#2C3035]">
        {{ 'dashboard.boostYourCommunity' | translate }}
      </div>
      <div class="text-[#505760] text-[0.8125rem]/[160%] md:text-[0.9375rem]">
        {{ 'dashboard.createPromotionsToGrowTheirEngagement' | translate }}
      </div>
    </div>
    <div class="flex gap-2 items-center">
      <img
        src="../../../../../assets/img/dashboard-v2/boost-your-community.svg"
        class="size-[3.5rem] md:size-[5rem]"
        alt=""
      />
      <!-- Growth CTA arrow hidden until the route is ready -->
    </div>
  </div>
</div>
